import Vue from "vue"
import { initialState } from "./state"

export const setUpload = (state, upload) => {
  Vue.set(state.uploads, upload.episodeKey, upload)
}

export const updateUpload = (state, { episodeKey, fields }) => {
  const upload = state.uploads[episodeKey]

  if (upload) {
    Vue.set(state.uploads, episodeKey, { ...upload, ...fields })
  }
}

export const removeUpload = (state, episodeKey) => {
  Vue.delete(state.uploads, episodeKey)
}

export const reset = (state) => {
  const s = initialState()
  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
